import { Button } from "@mui/material";
import { useConfirm } from "material-ui-confirm";
import { Trans, useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { styled } from "@mui/material/styles";

import { useCase } from "src/hooks/useCase";
import { useStartCalculation } from "src/hooks/useStartCalculation";
import { CaseStatus } from "src/types";
import { ErrorsDialog } from "./ErrorsDialog";
import { useState } from "react";
import { useInterval } from "src/hooks/useInterval";

interface Props {
  caseId: string | number;
  // onStartCalculation: () => void;
  // onViewResults: () => void;
}

export function CaseStatusButton(props: Props) {
  const { t } = useTranslation();
  const { data: acase, refetch } = useCase(props.caseId);
  const confirm = useConfirm();
  const navigate = useNavigate();
  const location = useLocation();

  const startCalculation = useStartCalculation(props.caseId);

  useInterval(
    () => {
      refetch();
    },
    acase?.status !== CaseStatus.CALCULATING ? null : 5000
  );


  /**
   * Functions
   */
  async function handleStartCalculation() {
    await confirm({
      confirmationButtonProps: { autoFocus: true },
      title: t("label.areYouSure"),
      description: <Trans i18nKey={"label.startCalculationConfirm"} />,
    });
    startCalculation.mutation.mutateAsync();
  }

  function handleViewResults() {
    navigate(`/cases/${props.caseId}/results`);
  }

  function handleViewConfig() {
    navigate(`/cases/${props.caseId}`);
  }

  return render();

  function render() {
    if (!acase) return null;

    if (acase.status === CaseStatus.CREATION_FINISHED) return renderStartCalculation();

    if (acase.status === CaseStatus.CALCULATION_FINISHED) return renderViewResults();

    if (acase.status === CaseStatus.CALCULATION_FAILED)
      return (
        <>
          {renderStatic(t(`label.caseStatus.${acase.status}`))}
          {renderStartCalculation()}
        </>
      );

    return renderStatic(t(`label.caseStatus.${acase.status}`));
  }

  function renderStartCalculation() {
    return (
      <>
        <Button color="primary" variant="contained" onClick={() => handleStartCalculation()}>
          {t("label.startCalculation")}
        </Button>

        {startCalculation.mutation.error?.response?.data && (
          <ErrorsDialog
            data={startCalculation.mutation.error?.response?.data}
            open={startCalculation.isDialogOpen}
            onClose={() => {
              startCalculation.setIsDialogOpen(false);
            }}
          />
        )}
      </>
    );
  }

  function renderViewResults() {
    return (
      <>
        {location.pathname.includes("results") && (
          <Button color="primary" variant="outlined" onClick={() => handleViewConfig()}>
            {t("label.viewCaseConfig")}
          </Button>
        )}
        {!location.pathname.includes("results") && (
          <Button color="primary" variant="outlined" onClick={() => handleViewResults()}>
            {t("label.viewResults")}
          </Button>
        )}
      </>
      // <Routes>
      //   <Route
      //     path="results"
      //     element={
      //       <Button color="primary" variant="outlined" onClick={() => handleViewConfig()}>
      //         {t("label.viewCaseConfig")}
      //       </Button>
      //     }
      //   ></Route>
      //   <Route
      //     path="*"
      //     element={
      //       <Button color="primary" variant="outlined" onClick={() => handleViewResults()}>
      //         {t("label.viewResults")}
      //       </Button>
      //     }
      //   ></Route>
      // </Routes>
    );
  }

  function renderStatic(text: string) {
    return (
      <StaticButton
        color="info"
        variant="text"
        disableRipple={true}
        disableFocusRipple={true}
        disableTouchRipple={true}
        disabled
      >
        <i>{t("label.status")}: </i> {text}
      </StaticButton>
    );
  }
}

const StaticButton = styled(Button)`
  text-transform: none;

  i {
    font-style: italic;
    padding-right: 5px;
  }
`;
